import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { mellIcon } from '../../assets';
import { TRootState } from '../../store/store';
import './Pool.scss';

const poolSections = [true, true, true, true, true, true, true, true, true, false];

function numberFormat(num: number): string {
    return new Intl.NumberFormat('en-US').format(num).replace(/,/g, '’');
}

const Pool = () => {
    const { t } = useTranslation();
    const pollHunter = useSelector((state: TRootState) => state.schemes.value.poolHunter);
    const [active, setActive] = useState(pollHunter?.cards && pollHunter?.cards.length > 0 ? true : false);

    return (
        <div className="pool">
            <div className="pool__header">
                <h1>{t('pool.header')}</h1>
                <p>
                    <img
                        src={mellIcon}
                        alt=""
                    />
                    {numberFormat(parseInt(pollHunter?.info?.accumulatedValue || '0'))}
                </p>
            </div>
            <div className="line"></div>
            <div className="pool__content">
                {!active && <p dangerouslySetInnerHTML={{ __html: t('pool.content.no_active', { position: 'P6' }) }}></p>}
                {active && <p dangerouslySetInnerHTML={{ __html: t('pool.content.active') }}></p>}

                {active && (
                    <div className="actives">
                        <div className="amount">
                            <p>
                                <span>{pollHunter?.cards[0]?.energyValue}</span>/10
                            </p>
                        </div>
                        <div className="sections">
                            {poolSections.map((section, index) => (
                                <div
                                    key={index}
                                    className={`section ${
                                        pollHunter?.cards[0]?.energyValue && index + 1 <= pollHunter?.cards[0]?.energyValue ? 'active' : ''
                                    }`}
                                    onClick={() => setActive(!section)}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="16"
                                        viewBox="0 0 9 16"
                                        fill="none">
                                        <path
                                            d="M3.67592 10.1309C2.93116 10.1309 2.21196 10.1309 1.49277 10.1309C1.34905 10.137 1.20517 10.1243 1.06443 10.0931C0.909912 10.0492 0.767747 9.96669 0.650019 9.85256C0.532291 9.73844 0.44248 9.59609 0.388221 9.4376C0.333961 9.27912 0.316856 9.10918 0.33836 8.94225C0.359864 8.77532 0.419341 8.61631 0.511736 8.47876C1.27169 7.32763 2.04477 6.18158 2.81164 5.03336L5.43072 1.11311C5.61726 0.834595 5.8639 0.70152 6.19068 0.777875C6.51746 0.854229 6.73232 1.04766 6.79243 1.39598C6.81025 1.53913 6.79895 1.68464 6.75926 1.82284C6.38343 3.33684 6.00368 4.84987 5.62002 6.36192C5.61449 6.38447 5.61104 6.40846 5.60206 6.45573C5.67114 6.45573 5.7278 6.46591 5.78721 6.46591C6.47808 6.46591 7.16895 6.47173 7.85982 6.46591C8.29023 6.46082 8.6253 6.62589 8.82703 7.03166C9.02877 7.43743 8.97004 7.8192 8.72202 8.18934C7.09848 10.6133 5.4777 13.0372 3.85969 15.4612C3.67039 15.7441 3.42789 15.8931 3.09282 15.819C2.77226 15.7462 2.54634 15.5521 2.48417 15.2081C2.46505 15.0591 2.47684 14.9075 2.51871 14.7638C2.8904 13.2644 3.26968 11.762 3.64621 10.2611C3.6545 10.2269 3.6621 10.1927 3.67592 10.1309Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Pool;
